document.addEventListener("DOMContentLoaded", function () {
  var sliderThumbnail = new Swiper(".custom_media-thumb_main", {
    slidesPerView: 5,
    spaceBetween: 5,
    freeMode: true,
    direction: "vertical",
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    breakpoints: {
      0: {
        direction: "horizontal",
        slidesPerView: 4,
        spaceBetween: 5,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
      },
      481: {
        direction: "horizontal",
        slidesPerView: 5,
        spaceBetween: 5,
        freeMode: true,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
      },
      990: {
        direction: "vertical",
        slidesPerView: 3,
        spaceBetween: 0,
      },
      1025: {
        direction: "vertical",
        slidesPerView: 4,
        freeMode: true,
        direction: "vertical",
        spaceBetween: 0,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
      },
      1301: {
        slidesPerView: 5,
        freeMode: true,
        direction: "vertical",
        spaceBetween: 0,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
      },
    },
  });
  var slider = new Swiper(".custom_products_media_main", {
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    thumbs: {
      swiper: sliderThumbnail,
    },
    autoHeight: true,
  });

  function slideToIndex(index) {
    slider.slideTo(index);
  }
  function updateHeight() {
    var windowWidth = window.innerWidth;
    var mediaThumbElement = document.querySelector(".custom_media-thumb_main");

    if (!mediaThumbElement) return;

    if (windowWidth >= 990) {
      var get_mainh_image_height =
        document.querySelector(".custom_products_media_main")?.offsetHeight ||
        "auto";
      mediaThumbElement.style.height = get_mainh_image_height + "px";
    } else {
      mediaThumbElement.style.height = "";
    }
  }
  updateHeight();
  window.addEventListener("resize", updateHeight);

  var variantImage2 = document.querySelector(".swatch-input__input:checked");
  if (variantImage2) {
    var variantImageValue = variantImage2.getAttribute("variant-image");
    var mediaRepeater = document.querySelector(
      '.custom_products_media_main .custom_media_rpeater[data-image="' +
        variantImageValue +
        '"]'
    );
    var dataSliderIndex3 = mediaRepeater
      ? mediaRepeater.getAttribute("data-index")
      : null;
    slideToIndex(dataSliderIndex3);
  }

  document
    .querySelector(".product__info-container")
    ?.addEventListener("change", function (event) {
      if (event.target.matches(".swatch-input__input")) {
        var variantImage = event.target.getAttribute("variant-image");
        // console.log(event.target);
        var mediaRepeater = document.querySelector(
          '.custom_products_media_main .custom_media_rpeater[data-image="' +
            variantImage +
            '"]'
        );
        var dataSliderIndex = mediaRepeater
          ? mediaRepeater.getAttribute("data-index")
          : null;
        slideToIndex(dataSliderIndex);
      }
    });
  const addoncheckbox = document.querySelector(".add_on-products_outer input");
  const originalbtn = document.querySelector(".original_cart_btn");
  const addonbtn = document.querySelector(".add_on_cart_btn");
  addoncheckbox?.addEventListener("change", function () {
    if (addoncheckbox.checked) {
      originalbtn.style.display = "none";
      addonbtn.style.display = "block";
    } else {
      originalbtn.style.display = "block";
      addonbtn.style.display = "none";
    }
  });

  document.addEventListener("click", function (event) {
    if (event.target && event.target.matches(".add_on_cart_btn")) {
      const sections = Array.from(
        document.querySelector("cart-notification").getSectionsToRender()
      ).map(function (section) {
        return section.id;
      });
      const get_main_id = event.target
        .closest(".product-form")
        .querySelector(".product-variant-id").value;
      const get_main_qty = event.target
        .closest(".product__info-container")
        .querySelector(".quantity__input").value;
      const addon_pro_id = event.target
        .closest(".product__info-container")
        .querySelector(".add_on-products_outer")
        .getAttribute("data-selected-id");

      // Create the form data with items and sections
      let formData = {
        items: [
          {
            id: get_main_id,
            quantity: get_main_qty,
          },
          {
            id: addon_pro_id,
            quantity: 1,
          },
        ],
        sections: sections, // Add the sections array here
      };

      // Send the request with the updated formData
      fetch(window.Shopify.routes.root + "cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (response) {
          // console.log(response);

          // Update cart icon bubble
          const cartIconBubbleHtml = response.sections["cart-icon-bubble"];
          const create_custom_div = document.createElement("div");
          create_custom_div.innerHTML = cartIconBubbleHtml;
          const cartIconBubbleElement = create_custom_div.querySelector(
            "#shopify-section-cart-icon-bubble"
          );
          const cartIconBubbleData = cartIconBubbleElement.innerHTML;
          document.querySelector("#cart-icon-bubble").innerHTML =
            cartIconBubbleData;

          // Update cart notification button
          const cartnotificatiion_btn =
            response.sections["cart-notification-button"];
          const create_custom_div2 = document.createElement("div");
          create_custom_div2.innerHTML = cartnotificatiion_btn;
          const cart_noti_btnele = create_custom_div2.querySelector(
            "#shopify-section-cart-notification-button"
          );
          const cartIconnotiData = cart_noti_btnele.innerHTML;
          document.querySelector("#cart-notification-button").innerHTML =
            cartIconnotiData;

          // Update cart notification product
          const cartnotificatiion_product =
            response.sections["cart-notification-product"];
          const create_custom_div3 = document.createElement("div");
          create_custom_div3.innerHTML = cartnotificatiion_product;
          const cart_noti_product = create_custom_div3.querySelector(
            "#shopify-section-cart-notification-product"
          );
          const cartIconnotiprodata = cart_noti_product.innerHTML;
          document.querySelector("#cart-notification-product").innerHTML =
            "<div class='products_inner-wrapp'>" +
            cartIconnotiprodata +
            "</div>";
          // Show the cart notification

          for (let i = 0; i < response.items.length; i++) {
            document.getElementById(
              "cart-notification-product-" + response.items[i].key
            ).style.display = "flex";
          }

          document.querySelector("#cart-notification").classList.add("active");
        })
        .catch(function (error) {
          console.error("Error:", error);
        });
    }
  });
});
